export const IMG_PREFIX = 'https://sdk-source.xylink.com/website/assets/home/new_product_2024/';
export const features = {
  MCU: ['超大容量、无限级联', '一机双擎、多流转发', '信创国产化、多活热备', '4K超高清、品质体验'],
  doubleMode: ['双模双栈、自由切换', '国密认证、安全可靠', '灵活开放、融合生态', '双机热备、稳定保障'],
  secret: ['自主可控、安全合规', '国密算法、身份认证', '灵活扩容、高可用性', '4K超高清，沉浸会议'],
  AI: ['智能助手、高效会议', '数字人应用、智慧化体验', '语音引擎、智能纪要', '虚拟会议、无限畅想'],
};
export const tabList = [
  {
    title: '原厂自研',
    name: '专业服务、极致体验',
    desc: '云原生架构，模块化设计\n采用分级管控，多重安全保障',
    imgUrl: IMG_PREFIX + 'platform_1.jpg',
  },
  {
    title: '多品牌融合',
    name: '全面融合、高效集中',
    desc: '打通多种不同视频会议平台及品牌\n会议系统、流程、数据、空间全融合',
    imgUrl: IMG_PREFIX + 'platform_2.jpg',
  },
  {
    title: '一站式管理',
    name: '智能运维、降本增效',
    desc: '预约、建会、管理、运维、会控一平台全操作\n全面降低管理运维成本',
    imgUrl: IMG_PREFIX + 'platform_3.jpg',
  },
  {
    title: '全流程打通',
    name: '会议贯穿、操作简便',
    desc: '会前/会中/会后全流程会管\n流程全打通、一键全掌控，数据全统计、一屏全呈现',
    imgUrl: IMG_PREFIX + 'platform_4.jpg',
  },
];

export const tabList2 = [
  {
    title: '超便捷集成',
    name: '快速集成、轻量开发',
    desc: '两行代码1分钟跑通Demo\n灵活定制、高效配置，快速集成上线',
    imgUrl: IMG_PREFIX + 'devPlatform_1.jpg',
  },
  {
    title: '全平台支持',
    name: '软硬件结合、多平台互通',
    desc: '软硬件无缝接入业务系统，多开发语言兼容\nAndroid、iOS、Windows、Web、Electron、macOS、小程序等全平台SDK支持',
    imgUrl: IMG_PREFIX + 'devPlatform_2.jpg',
  },
  {
    title: '多样化部署',
    name: '多元部署、信创国产化',
    desc: '公有云、私有云、混合云等多种部署方式，多网络兼容\n支持主流国产化平台，全面保障音视频通讯安全',
    imgUrl: IMG_PREFIX + 'devPlatform_3.jpg',
  },
  {
    title: '全场景应用',
    name: '灵活开放、视频赋能',
    desc: '全面适配全行业的业务场景需求\n实现协同办公、数字政府、在线金融、智慧政法等全场景应用',
    imgUrl: IMG_PREFIX + 'devPlatform_4.jpg',
  },
];
